import { ApiResponseWithData, EventPurchaseLimits } from "./models";
import { getJson } from "../../../../utils";
import { constants } from "../../common";
import { createReadthroughCache } from "./apiCache";

const apiCall = (eventId: number) =>
  getJson<ApiResponseWithData<EventPurchaseLimits[]>>(constants.urls.eventV2.limits(eventId));
const fetchEventLimits = createReadthroughCache("event/limits", 60_000, apiCall);

export default fetchEventLimits;
